
import { Record } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { DTO_ProcedureFormDto, ProcedureInformationFieldValueDto, DTO_ProcedureTemplateDto, DTO_ProcedureDto, ProcedureState, DTO_ProcedureTemplateTestElementDto, DTO_ProcedureTemplateStepDto, DTO_ProcedureTemplateStepElementDto, DTO_ProcedureTemplateTestElementDto_$reflection, DTO_ProcedureFormDto_$reflection } from "../../Shared/Procedure.js";
import { record_type, list_type } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { bind, map, defaultArg } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { empty, collect, sortBy, map as map_1, tryFind } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { PropertyConfigurationId__get_unwrap } from "../../Shared/Shared.js";
import { newGuid } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Guid.js";
import { comparePrimitives } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { now } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Date.js";

export class ProcedureTestRun extends Record {
    constructor(ProcedureForm, Elements) {
        super();
        this.ProcedureForm = ProcedureForm;
        this.Elements = Elements;
    }
}

export function ProcedureTestRun_$reflection() {
    return record_type("Widgets.Procedure.TestRun.ProcedureTestRun", [], ProcedureTestRun, () => [["ProcedureForm", DTO_ProcedureFormDto_$reflection()], ["Elements", list_type(DTO_ProcedureTemplateTestElementDto_$reflection())]]);
}

function informationFieldLabel(propertyConfigurations, fieldType) {
    switch (fieldType.tag) {
        case 1:
            return "procedure.information_fields.manufacturer";
        case 2:
            return "procedure.information_fields.model";
        case 3:
            return "procedure.information_fields.serial_number";
        case 4:
            return "procedure.information_fields.inventory_number";
        case 5:
            return "procedure.information_fields.comment";
        case 6:
            return "procedure.information_fields.storage_name";
        case 7:
            return "procedure.information_fields.storage_space";
        case 8:
            return defaultArg(map((_arg) => _arg.Name, tryFind((configuration) => (PropertyConfigurationId__get_unwrap(configuration.Id) === fieldType.fields[0]), propertyConfigurations)), "procedure.information_fields.custom_field");
        default:
            return "procedure.information_fields.display_name";
    }
}

function withTestIds(template) {
    return map_1((step) => {
        let copyOfStruct;
        return [(copyOfStruct = newGuid(), copyOfStruct), step, map_1((element) => {
            let copyOfStruct_1;
            return [(copyOfStruct_1 = newGuid(), copyOfStruct_1), element];
        }, sortBy((_arg_1) => (_arg_1.Position | 0), step.Elements, {
            Compare: (x_1, y_1) => (comparePrimitives(x_1, y_1) | 0),
        }))];
    }, sortBy((_arg) => (_arg.Position | 0), template.Steps, {
        Compare: (x, y) => (comparePrimitives(x, y) | 0),
    }));
}

export function createTestRun(template, inspectionTemplates, propertyConfigurations) {
    let copyOfStruct, copyOfStruct_1;
    const steps = withTestIds(template);
    const templateSteps = map_1((tupledArg) => {
        const step = tupledArg[1];
        return new DTO_ProcedureTemplateStepDto(tupledArg[0], step.Name, step.Description, step.Position, map_1((tupledArg_1) => {
            const element = tupledArg_1[1];
            return new DTO_ProcedureTemplateStepElementDto(tupledArg_1[0], element.Label, element.Position, element.Type, element.Options, element.InspectionTemplateId, map((_arg) => _arg.Name, bind((id) => tryFind((inspectionTemplate) => (inspectionTemplate.Id === id), inspectionTemplates), element.InspectionTemplateId)), element.PropertyConfigurationId, element.MinCount, element.MaxCount, element.AttachProtocolPdf, element.EmailRecipients, element.EmailSubject, element.EmailBody, element.AllowRecipientEditing);
        }, tupledArg[2]));
    }, steps);
    const elements_2 = collect((tupledArg_2) => map_1((tupledArg_3) => {
        const element_1 = tupledArg_3[1];
        return new DTO_ProcedureTemplateTestElementDto(tupledArg_3[0], element_1.Type, element_1.Required, element_1.MinCount, element_1.MaxCount, element_1.Options);
    }, tupledArg_2[2]), steps);
    return new ProcedureTestRun(new DTO_ProcedureFormDto(new DTO_ProcedureDto((copyOfStruct = "00000000-0000-0000-0000-000000000000", copyOfStruct), new ProcedureState(0, []), template.Name, template.Description, now(), undefined, empty()), new DTO_ProcedureTemplateDto((copyOfStruct_1 = "00000000-0000-0000-0000-000000000000", copyOfStruct_1), template.Name, template.Description, templateSteps), map_1((field) => (new ProcedureInformationFieldValueDto(informationFieldLabel(propertyConfigurations, field.FieldType), "")), sortBy((_arg_3) => (_arg_3.Position | 0), template.InformationFields, {
        Compare: (x, y) => (comparePrimitives(x, y) | 0),
    })), undefined, empty(), undefined, undefined, undefined, undefined, empty(), empty()), elements_2);
}

